/* @flow */
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Container from 'components/Container';
import Dialog from 'components/Dialog';
import Glyph from 'components/Glyph';
import Image from 'components/Image';
import Link from 'components/Link';
import * as React from 'react';
import userAgent from 'lib/currentUserAgent';
import WebNotificationActions from 'notifications/WebNotificationActions';
import errorLogger from 'utils/errorLogger';
// eslint-disable-next-line no-unused-vars
import type { Element } from 'react';

import './WebNotificationTutorialModal.scss';

type Props = {
  onRequestHide: Function,
};

class WebNotificationTutorialModal extends React.Component<Props> {
  componentDidMount() {
    this.askForPermission();
  }

  askForPermission() {
    WebNotificationActions.askForPermission()
      .then(() => this.props.onRequestHide())
      .catch(errorLogger('WebNotificationActions.askForPermission failed'));
  }

  renderAskButton(): ?React.Element<any> {
    if (userAgent.firefox()) {
      return (
        <Button
          className="WebNotificationTutorialModal-body-button"
          onClick={this.askForPermission}
          level="secondary"
          eventElementName="WebNotificationTutorialModal-body-button">
          Show dialog again
        </Button>
      );
    }
    return null;
  }

  renderCloseLink(): ?React.Element<any> {
    if (!userAgent.safari()) {
      return (
        <Link
          className="WebNotificationTutorialModal-close"
          onClick={this.props.onRequestHide}
          eventElementName="WebNotificationTutorialModal-close">
          <Glyph name="close" size="large" solo />
        </Link>
      );
    }
    return null;
  }

  renderImage() {
    if (userAgent.safari()) {
      return (
        <Image
          className="WebNotificationTutorialModal-body-image-up"
          src={require('assets/images/notifications/plane-flying-up.svg')}
        />
      );
    } else {
      return (
        <Image
          className="WebNotificationTutorialModal-body-image-left"
          src={require('assets/images/notifications/plane-flying-left.svg')}
        />
      );
    }
  }

  render() {
    return (
      <Dialog box={false} hideCloseButton className="WebNotificationTutorialModal">
        {this.renderCloseLink()}
        <Container className="WebNotificationTutorialModal-container" size="small">
          <BoxBody className="WebNotificationTutorialModal-body">
            {this.renderImage()}
            <div className="WebNotificationTutorialModal-body-title">
              Turn on desktop notifications
            </div>
            <div className="WebNotificationTutorialModal-body-subtext">
              {'Click "Allow" in the dialog to get notifications for new messages and updates.'}
            </div>
            {this.renderAskButton()}
          </BoxBody>
        </Container>
      </Dialog>
    );
  }
}

export default WebNotificationTutorialModal;
